import type { BandView } from '@/api/tmm/types';
import { NOT_SENT, formatMoney } from './money';

/** A seat-price ladder as text: "1–5: $10.00 + $2.00; 6–∞: $0.00 + $1.00". */
export function formatSeatBands(bands: BandView[], currency: string, locale: string): string {
  if (bands.length === 0) return NOT_SENT;
  return bands
    .map((band) => {
      const range = `${band.from}–${band.to ?? '∞'}`;
      const flat = formatMoney(band.flatMinor, currency, locale);
      const per = formatMoney(band.perUnitMinor, currency, locale);
      return `${range}: ${flat} + ${per}`;
    })
    .join('; ');
}
